import { render, staticRenderFns } from "./PostCodeExportDialog.vue?vue&type=template&id=1223b27a&"
import script from "./PostCodeExportDialog.vue?vue&type=script&lang=js&"
export * from "./PostCodeExportDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports